import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface EmployeeTemporaryCredentialsDialogData {
  title?: string;
  description?: string;
  account: string;
  accountLabel: string;
  password: string;
  mustChangePassword: boolean;
}

@Component({
  selector: 'app-employee-temporary-credentials-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './employee-temporary-credentials-dialog.component.html',
  styleUrl: './employee-temporary-credentials-dialog.component.scss',
})
export class EmployeeTemporaryCredentialsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<EmployeeTemporaryCredentialsDialogComponent>);
  readonly data = inject<EmployeeTemporaryCredentialsDialogData>(MAT_DIALOG_DATA);

  password = this.data.password;
  copied = false;
  copyFailed = false;

  async copyPassword(): Promise<void> {
    if (!this.password) {
      return;
    }

    try {
      await navigator.clipboard.writeText(this.password);
      this.copied = true;
      this.copyFailed = false;
      this.password = '';
    } catch {
      this.copyFailed = true;
    }
  }

  close(): void {
    this.password = '';
    this.dialogRef.close();
  }
}
